import React, { Fragment } from 'react'

const Footer = () => {
    return (
        <Fragment>
            <div className="footer">
                <div className='footer__panel'>
                    <div className='footer__copy'>
                        <strong>Friends of Bukit Kiara</strong>
                        <p>Explore Bukit Kiara Federal Park, FoBK programmes, and ways to hike, volunteer, learn, and support the movement on the main site.</p>
                    </div>
                    <div className='footer__meta'>
                        <span>Public information and updates live on FoBK.org</span>
                        <div className='footer__actions'>
                            <a href='https://www.fobk.org/' target='_blank' rel='noreferrer' className='footer-button'>Visit FoBK.org</a>
                            <a href='https://qworky.tech' target='_blank' rel='noreferrer' className='footer-link'>Powered by Qworky</a>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Footer
